// extracted by mini-css-extract-plugin
export default {"catalogItems":"style_catalogItems__y5WLI","catalogItemsWithoutHeaderPhoto":"style_catalogItemsWithoutHeaderPhoto__WZLkw"};